export function getFormattedMonth(publishedAT: Date) {
    const date = new Date();
    date.setMonth(Number(publishedAT.toLocaleString().slice(5, 7)) - 1);
    return date.toLocaleString('en-US', { month: 'short' });
}

export function getFormattedDate(publishedAT: Date) {
    return Number(publishedAT.toLocaleString().slice(8, 10));
}

export function isBeforeYesterday(date: Date): boolean {
    return date.getTime() < (Date.now() - 86400000) ? true : false;
}

export const dateFormatter = (field_value: string): string => {
    let day = field_value.slice(0, 2);
    let month = field_value.slice(3, 5);
    let year = field_value.slice(6);
    let date = `${year}-${month}-${day} 00:00:00.000`;
    return date;
}

export const isoDateToString = (date: string,separator?:string): string => { 
    if(!date){
      return '';
    }
    
    let [year, month, day] = date.split('-');
    return `${day}${separator ?? '/'}${month}${separator ?? '/'}${year}`;
}

export const dateToString = (date?: Date, fullDisplay?: boolean): string => {
    const newDate = new Date(date ? date : '');
    if (fullDisplay) {
        let dateString = newDate.toLocaleDateString('sr-Latn-RS', { weekday: "short", year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
        return dateString;
    }
    let dateString = newDate.toLocaleDateString('sr-Latn-RS');
    dateString = dateString.replaceAll('/', '.');
    let timeString = newDate.toLocaleTimeString('sr-Latn-RS');
    return dateString + ' / ' + timeString.slice(0, timeString.lastIndexOf(':'));
}

export const stringToDate = (date: string): Date => {
    return new Date(
        +date.slice(date.length - 4),
        +date.slice(3, 5) - 1,
        +date.slice(0, 2) + 1
    );
}

export const stringToIsoDate = (date: string, separator: string = '.'): string => {
    let [day, month, year] = date.split(separator);
    return `${year}-${month}-${day}`;
}